import { Component, Input }    from '@angular/core';

@Component({
  template: require('./transaction-row.component.html')
})
export class TransactionRowComponent {
  @Input() set record (_record: any) {
    console.log(_record);
  }
}